var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'screen-link '+ _vm.dotClass,style:(_vm.linkStyle),attrs:{"data-active":"active","data-show-dot":_vm.showDot}},[(_vm.textSlot)?_c('div',{staticClass:"slot-text"},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }